import styled from 'styled-components';

import { ORANGE, RED, TEXT, PRIMARY } from 'constants/colors';

export default styled.div`
  height: 100%;
  color: ${TEXT};

  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    color: ${TEXT};
    margin-top: 0;
    font-family: 'SourceSansPro-Regular';
  }

  .regular {
    font-family: 'SourceSansPro-Regular';
  }

  .semibold {
    font-family: 'SourceSansPro-Bold';
  }

  .dojo-content {
    h1,
    h2,
    h3,
    h4,
    h5,
    p {
      font-family: 'SourceSansPro-Regular', Arial, 'sans-serif';
    }
  }

  b,
  strong,
  .bold {
    font-weight: normal;
    font-family: 'SourceSansPro-Bold';
  }

  .red {
    color: ${RED};
  }

  .orange {
    color: ${ORANGE};
  }

  .primary {
    color: ${PRIMARY};
  }
`;
